<template>
	<div
		id="docSubtype-management"
		:class="[!isWeb ? 'mobile-docSubtype-management' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="docSubtype-management__body">
			<TableFilter :isWeb="isWeb" @searchFromInput="searchFromInput" />
			<DocSubtypeTable
				:isWeb="isWeb"
				:currentPage="page"
				@changePage="changePage"
				@refreshDocSubtype="refreshDocSubtype"
				@orderByHeader="orderByHeader"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { GET_ALL_DOC_SUBTYPES } from '@/store/modules/docSubtypeManagement/actions';
import TableFilter from '@/components/modules/DocSubtype/DocSubtypeManagement/TableFilter/TableFilter.vue';
import DocSubtypeTable from '@/components/modules/DocSubtype/DocSubtypeManagement/Table/Table.vue';

export default {
	name: 'DocSubtypeManagement',
	components: { TableFilter, DocSubtypeTable },
	data: () => ({
		windowWidth: window.innerWidth,
		page: 1,
		searchParams: null,
		headerSelected: null,
		orderSelected: null,
	}),
	created() {
		this.refreshDocSubtype();
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		...mapActions('docSubtypeManagement', {
			getDocsSubtypes: GET_ALL_DOC_SUBTYPES,
		}),
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		changePage(params) {
			this.page = params.params;
			this.refreshDocSubtype();
		},
		searchFromInput(params) {
			this.searchParams = params;
			this.page = 1;
			this.refreshDocSubtype();
		},
		orderByHeader(param) {
			this.headerSelected = param;

			if (!this.orderSelected || this.orderSelected == 'ASC') {
				this.orderSelected = 'DESC';
			} else {
				this.orderSelected = 'ASC';
			}

			this.refreshDocSubtype();
		},
		refreshDocSubtype() {
			let params = `?limit=20&page=${this.page}`;
			if (this.searchParams) params += `&search=${this.searchParams}`;
			if (this.headerSelected)
				params += `&orderColumn=${this.headerSelected}&orderDirection=${this.orderSelected}`;

			this.getDocsSubtypes({ vm: this, params: params });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'DocSubtypeManagement.scss';
</style>
